import translations from './translations.js';

export default (language = 'en_US') => {
  let data = {
    title: translations('title', language),
    submitText: translations('submitText', language),
    showCancelButton: true,
    canClose: false,
    cancelText: translations('cancelText', language),
  };
  return data;
};